// extracted by mini-css-extract-plugin
module.exports = {"moduleSettingsErrorTab":"EditUser_moduleSettingsErrorTab__1u0Vw"};